module.exports = MathJax;